<template>
  <div class="home">
      <div class="container">
        <div class="row text-center">
          <div class="col-md-12">
            <div class="hero-img wow fadeIn">
              <img class="img-fluid" src="@/assets/images/big.png" alt="Home">
            </div>
          </div>
          <div class="col-md-12">
            <div class="hero-content wow fadeIn">
              <h1>Hi, I'm a software architecture and Web developer.</h1>
              <p>I'am able to build a Web presence from the ground up - from concept, navigation, layout and programming to software deployment.</p>
              <a class="btn-action js-scroll-trigger" target="_blank" href="https://www.linkedin.com/in/mauriciosneira/">Linkedin</a>
            </div>
          </div>
          <div class="col-md-12">
            <div class="client-list wow fadeIn">
              <ul>
                  <li><img class="img-fluid" src="@/assets/icons/6.png" alt="Client"> </li>
                <li><img class="img-fluid" src="@/assets/icons/2.png" alt="Client"> </li>
                <li><img class="img-fluid" src="@/assets/icons/3.png" alt="Client"> </li>
                <li><img class="img-fluid" src="@/assets/icons/5.png" alt="Client"> </li>
                <li><img class="img-fluid" src="@/assets/icons/4.png" alt="Client"> </li>
                <li><img class="img-fluid" src="@/assets/icons/1.png" alt="Client"> </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Home',
  components: {
  }
}
</script>

<style lang="stylus">
  @media only screen and (min-width: 240px)
    .home
      padding: 100px 0 50px 0
      .hero-img img
        max-width: 720px !important
        width: 100%
        margin: 20px 0
      h1
        font-size: 28px
        font-weight: 600
        color: #FFFFFF
        color: #364655
        line-height: 1.2
        letter-spacing: 0
      p
        font-size: 16px
        font-weight: 500
        color: rgb(129, 129, 152)
        max-width: 630px
        margin: 0 auto
        letter-spacing: 0
        line-height: 1.6
        margin-top: 15px
      .client-list
        margin-top: 25px
        ul
          list-style-type: none
          li
            display: inline
            margin: 0 20px
            img
              width: 100px
              opacity: 0.6
              cursor: pointer
    .btn-action
      font-family: 'Montserrat'
      display: inline-block
      height: 38px
      padding: 0 30px
      text-align: center
      font-size: 12px
      font-weight: 600
      line-height: 36px
      letter-spacing: 2px
      margin: 25px 0
      text-transform: uppercase
      text-decoration: none !important
      white-space: nowrap;
      cursor: pointer;
      background-color: #387ed1
      background: #6d48e5
      color: #FFFFFF
      border: 1px solid transparent !important
      border-radius: 4px
      box-sizing: border-box;
      -webkit-transition: 0.2s
      -moz-transition: 0.2s
      transition: 0.2s

</style>